module.exports = __webpack_public_path__ + "img/icon3.babd3fc1.png";